module.exports = __webpack_public_path__ + "img/no-COD.32b4da77.svg";